<template>
  <div class="usa-accordion usa-accordion--bordered">
    <div class="usa-space">
      <!-- pooja, 02-jul-2025, 508 collapsible read only heading not with description( currentlty reading 2 time heading and image also)-->
        <button
           type="button"
          class="usa-accordion__button card-button-content"
          :aria-expanded="showSection ? 'true' : 'false'"
          :aria-controls="data.fields.sectionHeading"
          :class="{ active: showSection }"
          :aria-label="showlabel"
          @click="toggle"
        >
        <!-- pooja, 04-dec-2025, made a generic heading component handling -->
        <component :is="headingTag"  class="usa-accordion__heading">
          {{ data.fields.sectionHeading }}
        </component>
           <!-- Pooja, 11-dec-25, removed aria hidden from collapsible heading -->
          <span class="arrow-right">
            <img
              :src="showSection ? '/assets/img/minus.svg' : '/assets/img/plus.svg'"
              width="20"
              alt=""
              aria-hidden="true"
            />
          </span>
        </button>
      <div v-if = "!isCustomizePage"  class="usa-accordion__content" :class="{ active: showSection }" :id="data.fields.sectionHeading">
        <rich-text-renderer
          :data="data.fields.sectionBody"
        ></rich-text-renderer>
       </div>
      <div   v-if = "isCustomizePage" v-html ="data.fields.sectionHtml" class="usa-accordion__content" :class="{ active: showSection }" :id="data.fields.sectionHeading">
      </div>
    </div>
  </div>
</template>
<script>
import { LABEL_FOR_LANGING_PG,LABEL_FOR_STEP_5 } from "@/config";
import { urlSlug, getHeadingTag } from "@/helpers/url";
export default {
  name: "accordion-component",
  props: ["data", "additionaldata"],
  data() {
    return {
      showSection: false,
      isCustomizePage: true,
      htmlText: '',
    };
  },
  computed: {
    encapsulator() {
      return this.additionaldata && this.additionaldata.encapsulator;
    },
    showlabel() {
      const urlSlugText = urlSlug();
      if (urlSlugText == "") return LABEL_FOR_LANGING_PG + this.data.fields.sectionHeading;
      if (urlSlugText == "step-5") return LABEL_FOR_STEP_5 + this.data.fields.sectionHeading;
    },
    // pooja, 04-dec-2025, call a generic heading component handling
    headingTag() {
      return this.heading= getHeadingTag("h3", this.data.fields);
    }
  },
  watch: {
    'data.fields.sectionHtml': {
      handler(newVal) {
        if (newVal && newVal.trim() !== '') {
          this.relativeLink();
        }
      },
      immediate: true
    }
  },
  methods: {
    toggle() {
      this.showSection = !this.showSection;
    },
    // Pooja, 26-mar-2026, based on placeholder
    //  html content will be rendered relative link will be handled for that html content
    relativeLink() {
      console.log('location.origin - v1',location.origin);
      const currentOrigin = location.origin;
      let html = this.data?.fields?.sectionHtml || '';
      if (html.includes("{{BASE_URL}}")) {
        var re = new RegExp("{{BASE_URL}}", "g");
        this.htmlText = html.replace(re, currentOrigin);
        this.data.fields.sectionHtml = this.htmlText;
      }
    }
  },
  created() {   
    // Pooja, 26-mar-2026, based on placeholder
    //  html content will be rendered relative link will be handled for that html content
    // const html = this.data?.fields?.sectionHtml;
    // if (html && html.trim() !== '') {
    //   this.relativeLink();
    // }
    
    console.log(this.$route.path);
    if(this.$route.path == '/') {
       this.isCustomizePage = true;
     } else {
       this.isCustomizePage = false;
     }
    this.encapsulator &&
      this.encapsulator.$on("expand-all", () => {
        this.showSection = true;
      });
    this.encapsulator &&
      this.encapsulator.$on("collapse-all", () => {
        this.showSection = false;
      });
  }
};
</script>

<style lang="scss" scoped>
.plus {
  display: block;
}
.usa-accordion__button.active {
  //display: block;
  //background-image: url(/assets/img/minus.svg) !important;
  background-image: none !important;
}
.minus {
  display: none;
}
// .usa-accordion__button  {
//   //display: none;
//     background-image: url(/assets/img/plus.svg)!important;

// }
.usa-accordion__button[aria-expanded=false] {
  background-image: none !important;
}
.usa-space {
  margin-bottom: 11px;
}
.usa-accordion__content.active {
  display: block;
}
.usa-accordion__content {
  display: none;
  text-align: left;
  ::v-deep p {
    margin: 0 0 10px;
    padding: 0;
    &:last-child {
      margin: 0;
    }
  }
}
.usa-accordion__heading, .usa-prose .usa-accordion__heading {
  font-size: 1.06471rem !important;
}
.usa-accordion__button{
    display: flex;
    align-items: center;       
    justify-content: space-between;
    width: 100%;
    padding: 19px 33px 19px 19px;
    background-image: none !important;
}
.arrow-right {
  display: flex;
  align-items: center;
}
</style>